import { render, staticRenderFns } from "./SearchFolder.vue?vue&type=template&id=3a1a7254&"
import script from "./SearchFolder.vue?vue&type=script&lang=js&"
export * from "./SearchFolder.vue?vue&type=script&lang=js&"
import style0 from "./SearchFolder.vue?vue&type=style&index=0&id=3a1a7254&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports